import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from 'app/core/user/user.types';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({providedIn: 'root'})
export class UserService
{
    private _user = new BehaviorSubject<User | null>(null);

    constructor(private _httpClient: HttpClient)
    {
    }

    set user(value: User)
    {
        this._user.next(value);
    }

    /** Utente collegato (null prima dell'accesso). */
    get user$(): Observable<User | null>
    {
        return this._user.asObservable();
    }

    get current(): User | null
    {
        return this._user.value;
    }

    get isAdmin(): boolean
    {
        return !!this._user.value?.isAdmin;
    }

    /** Carica i dati dell'utente collegato dall'API. */
    get(): Observable<User>
    {
        return this._httpClient.get<User>('api/auth/me').pipe(
            tap((user) => this._user.next(user)),
        );
    }
}
